import adminApi from "../../api";

class AdminOrdersService {
  async getOrderStats(range = "7d") {
    const res = await adminApi.get(`/orders/stats?range=${range}`);
    return res.data;
  }

  async getOrders(page = 1, pageSize = 20) {
    const res = await adminApi.get(`/orders?page=${page}&pageSize=${pageSize}`);
    return res.data;
  }

  async getOrderById(id) {
    const res = await adminApi.get(`/orders/${id}`);
    return res.data;
  }

  async getKitchenBoard() {
    const res = await adminApi.get("/orders/kitchen");
    return res.data;
  }

  async patchOrderStatus(id, status) {
    const res = await adminApi.patch(`/orders/${id}/status`, { status });
    return res.data;
  }
}

export default new AdminOrdersService();
